<app-dialog-header>qa-psql token</app-dialog-header>

<div appDialogContent>
  <app-form-field
    class="token-field"
    label="Token">
    <input
      [value]="token"
      readonly />
  </app-form-field>

  <p class="warning">
    Token is shown only now. Open the terminal, run <code>qa-psql login</code> (for stage:
    <code>qa-psql --stage login</code>) and paste it. Do not share the token and do not paste it in chat.
  </p>
</div>

<div
  appDialogActions
  align="end">
  <app-button
    variant="stroked"
    color="neutral"
    (click)="copy()">
    <mat-icon>{{ copied() ? 'check' : 'content_copy' }}</mat-icon>
    {{ copied() ? 'Copied' : 'Copy' }}
  </app-button>
  <app-button appDialogClose>Close</app-button>
</div>
